export interface LocationStringMap {
    [key: string]: string | number | boolean;
}

export function combineLocationString(map: LocationStringMap = {}): string {
    return Object.keys(map)
        .map((key) => `${key}=${encodeURIComponent(String(map[key]))}`)
        .join('&');
}
